export default __webpack_public_path__ + "static/snaplock-70ebb85c8888309338b009ce65ffff9b.png";